var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 19.6895L15.086 14.0255C16.4471 12.3914 17.1258 10.2956 16.981 8.17389C16.8361 6.05219 15.8789 4.06801 14.3084 2.6341C12.7379 1.2002 10.675 0.42697 8.54893 0.475279C6.42284 0.523588 4.39723 1.38971 2.89347 2.89347C1.38971 4.39723 0.523588 6.42284 0.475279 8.54893C0.42697 10.675 1.2002 12.7379 2.6341 14.3084C4.06801 15.8789 6.05219 16.8361 8.17389 16.981C10.2956 17.1258 12.3914 16.4471 14.0255 15.086L19.6895 20.75L20.75 19.6895ZM1.99996 8.74996C1.99996 7.41494 2.39585 6.1099 3.13754 4.99987C3.87924 3.88983 4.93345 3.02467 6.16685 2.51378C7.40025 2.00289 8.75745 1.86921 10.0668 2.12966C11.3762 2.39011 12.5789 3.03299 13.5229 3.97699C14.4669 4.921 15.1098 6.12373 15.3703 7.4331C15.6307 8.74248 15.497 10.0997 14.9862 11.3331C14.4753 12.5665 13.6101 13.6207 12.5001 14.3624C11.39 15.1041 10.085 15.5 8.74996 15.5C6.96036 15.498 5.24463 14.7862 3.97919 13.5207C2.71375 12.2553 2.00195 10.5396 1.99996 8.74996Z",
    fill: "#767C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.516da5baaa9b63cba9e4459065d6b39a.svg";
export { ForwardRef as ReactComponent };